import { lazy, Suspense } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import NossosFones from '@/components/feature/NossosFones';

// Lazy-load all below-the-fold sections to reduce initial bundle size
const ServicesSection = lazy(() => import('./components/ServicesSection'));
const EquipmentSection = lazy(() => import('./components/EquipmentSection'));
const HowItWorksSection = lazy(() => import('./components/HowItWorksSection'));
const AboutSection = lazy(() => import('./components/AboutSection'));
const PortfolioPreview = lazy(() => import('./components/PortfolioPreview'));
const CitiesSection = lazy(() => import('./components/CitiesSection'));
const FAQSection = lazy(() => import('./components/FAQSection'));
const StatsSection = lazy(() => import('./components/StatsSection'));
const CTASection = lazy(() => import('./components/CTASection'));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection'));
const BlogPreview = lazy(() => import('./components/BlogPreview'));
const FeaturedArticles = lazy(() => import('./components/FeaturedArticles'));
const KeywordContentSection = lazy(() => import('./components/KeywordContentSection'));

// Minimal fallback — invisible placeholder that holds layout space
function SectionFallback() {
  return <div className="w-full" style={{ minHeight: '200px' }} aria-hidden="true" />;
}

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      <Header />
      <main>
        <HeroSection />
        <Suspense fallback={<SectionFallback />}>
          <KeywordContentSection />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <ServicesSection />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <EquipmentSection />
        </Suspense>
        <NossosFones />
        <Suspense fallback={<SectionFallback />}>
          <HowItWorksSection />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <AboutSection />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <PortfolioPreview />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <CitiesSection />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <TestimonialsSection />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <StatsSection />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <FAQSection />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <FeaturedArticles />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <BlogPreview />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <CTASection />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}